import {Component, Input} from '@angular/core';
import {OptionService} from "../option/option.service";
import {TranslateService} from "@ngx-translate/core";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

@Component({
    selector: 'event-header',
    templateUrl: './event.header.html',
    providers: []
})
export class EventHeaderComponent {
    /**
     * Size of the viewport
     *
     */
    @Input() size: string = null;

    /**
     * Toggle if the donation form is hidden.
     */
    @Input() donationFormHidden: boolean = false;

    /**
     * Image of the project
     */
    image: string = null;

    /**
     * youtubeUrl for the project if there is onw
     */
    youtubeUrl: SafeUrl = null;

    /**
     * Holds the type of the app that is currently shown
     */
    type: string = null;

    /**
     * teasertext for the project
     */
    teaser: string = null;

    /**
     * The logo of the project/orga
     */
    logo: string = null;

    /**
     * Name of the event
     */
    eventName: string = null;

    /**
     * should the logo be centered or not
     * @type {boolean}
     */
    logoCentered: boolean = false;

    /**
     * days until the event will end.
     */
    endDays: number = null;

    /**
     * URL that can be show if the event has expired.
     */
    endUrl: string;

    /**
     * The constructor
     * @param optionService
     * @param translate
     * @param sanitizer
     */
    constructor(private optionService: OptionService, private translate: TranslateService, private sanitizer: DomSanitizer) {}

    /**
     * Initialize the slider
     */
    public ngOnInit(): any {
        this.type = this.optionService.getType();
        this.logo = this.optionService.getOption("design_logo");
        if(this.optionService.getOption("has_hidden_logo") === true) {
            // hide the logo on the page
            this.logo = null;
        }
        this.image = this.optionService.getOption("image");
        this.eventName = this.optionService.getEventOption('description');
        this.teaser = this.optionService.getEventOption('text_teaser');
        this.logoCentered = this.optionService.getOption("design_logo_centered");

        const youtubeId = this.optionService.getEventOption('youtube_video_id');
        if(youtubeId) {
            this.youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + youtubeId);
        }

        // check if the event has an enddate
        const endsAt = this.optionService.getEventOption("ends_at");
        if(endsAt && this.donationFormHidden === false) {
            this.endDays = Math.floor(((endsAt * 1 + 86400) - (Date.now() / 1000)) / (86400));
        }

        // check if the event has ended
        if(this.donationFormHidden === true) {
            this.endUrl = this.optionService.getEventOption('ended_url');
            this.teaser = null;
        }
    }
}
